<template>
        <v-list class="scrollable-list">
            <v-list-item @click="$emit('selected',item)" v-for="(item, index) in timeList" :key="index" link>
                <v-list-item-title :id="uniqueId + item.replace(':','').replace(' ','')" >{{ item }}</v-list-item-title>
            </v-list-item>
        </v-list>
</template>

<script>
//   import { nextTick } from 'vue';

  export default {
    name: 'MitTimeSelect',
    components: {
    },
    props: {
      uniqueId:{
          default () {
              return 'time';
          },
          type: String
      },
      time:{
          default () {
              return null;
          },
          type: String
      },
      timeList:{
          default () {
              return [];
          },
          type: Array
      },
    },
    data: function() {
      return {}
    },
    created() {
    },
    mounted() {
        // console.log('s60', document.getElementById('s60'))
        // console.log('test9', document.getElementById('test9'))
        
        // document.getElementById('s60').focus();
        // document.getElementById('s60').scrollIntoView();
    //     console.log('mounted')
    //     const box = document.getElementById("s60");
    //     box.scrollIntoView();
    //     // document.getElementById('s60').scrollIntoView();
    //     console.log('F', document.getElementById('s60'))
        // this.$nextTick(() => {
        //     document.getElementById('s60').focus();
        //     document.getElementById('s60').scrollIntoView();
        //     console.log('nextTick')
        // });
    //     console.log('here3', this.$refs['s60'])
    //     this.$vuetify.goTo(this.$refs['s60'])
    //     // document.getElementById('s60').scroll();
    //     document.getElementById('s60').scroll({
    //     top: 100,
    //     left: 100,
    //     behavior: "smooth",
    //     });
        let id = this.uniqueId + this.time.replace(':','').replace(' ','');
        setTimeout(() => {
            document.getElementById(id).focus();
            document.getElementById(id).scrollIntoView();
        }, 100);
    //     var ref = document.getElementById('s60');
    //     window.scrollTo(0, ref.offsetTop - document.getElementsByClassName('header')[0].offsetHeight);
    //     setTimeout(function () {
    //        ref.scrollIntoView({
    //            behavior: "smooth",
    //            block: "start",
    //        });
    //   }, 100);
    },
    methods: {
        test(){
            document.getElementById('s60').scrollIntoView();
        }
    }
  }
</script>

<style lang="scss" scoped>
    .scrollable-list{
        height:200px;/* or any height you want */
        overflow:auto;
    }
</style>
